const APPLE_PLATFORM_PATTERN = /mac|iphone|ipad|ipod/i;

/**
 * Names the keyboard shortcut that opens search, in the form the user's keyboard shows it.
 *
 * @param platform - The platform name to check. Defaults to the current browser's platform.
 * @returns "⌘ K" on Apple platforms and "Ctrl K" everywhere else.
 */
export function getShortcutLabel(platform: string = detectPlatform()): string {
  return APPLE_PLATFORM_PATTERN.test(platform) ? "⌘ K" : "Ctrl K";
}

/** Reads the platform name from the browser, or an empty string where there is no `navigator`. */
function detectPlatform(): string {
  if (typeof navigator === "undefined") return "";
  const { userAgentData } = navigator as Navigator & { userAgentData?: { platform?: string } };
  return userAgentData?.platform || navigator.platform || "";
}
